export default function subCategoriesSort(data) {
    const customSortingOrder = [
        "Enteral",
        "Urologicals",
        "Ostomy-Products",
        "Respiratory---trachs-supply",
        "Trach-Tube",
        "Wound-Care",
        "Oral-Supplements",
        "G-tube"
      ];
      const sortedData = data.slice().sort((x, y) => {
        const indexX = customSortingOrder.indexOf(x.abrv);
        const indexY = customSortingOrder.indexOf(y.abrv);
    
        if (indexX === -1) return 1;
        if (indexY === -1) return -1;
    
        return indexX - indexY;
      });
      return sortedData;
}
